<script>
import { notify } from '@/helpers/notify' 

export default {
    name: 'SmsModal',
    props:[
        "data",
        "modelOpen"
    ],
    data() {
        return {
            content: '',
            submitted: false,
            smsHistory:[]
        };
    }, 
    watch:{
        modelOpen(){
            this.content= ''
            this.smsHistory= []
        },
        data(){
            this.getLastSms()
        }
    },
    methods: {
        close(){
            this.$parent.$bvModal.hide('sms_modal')
        },
        getLastSms(){
            this.$http.post('/members/'+ this.data.id +'/sms-list')
            .then(resp =>  this.smsHistory = resp.data )
        },
        handleSubmit(){
            this.$http.post(`/members/${this.data.id}/sms-send`, { content: this.content} )
            .then(response => {
                if(response.data.error) return notify.error(response.data.message)
                notify.success(response.data.message)
                this.content = ''
                this.close()
            })
        }
    },
};
</script>

<template>
<b-modal id="sms_modal" title="Sms Gönder" size="lg" no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <div class="mb-3">
            <label class="form-label d-block">  
               Sms Metni
            </label>
            <div class="">
                <input class="form-control" type="text" v-model="content">
            </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
                type="submit" 
                variant="success" 
                class="ms-1"
                >Kaydet
            </b-button>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <table class="table">
                <thead>
                    <tr>
                        <th>İçerik</th>
                        <th style="width:150px">Tarih</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="hist in smsHistory" :key="hist.id">
                        <td>{{ hist.message }}</td>
                        <td>{{ hist.created_at }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
</b-modal>
</template>